import { each, throttle } from "lodash";

declare const jQuery: any;
const $ = jQuery;

const $lgDetect = $(document.getElementById("lg-detect"));
const $mdDetect = $(document.getElementById("md-detect"));
const $headerLgDetect = $(document.getElementById("hd-lg-detect"));

let lg = detectLg();
let md = detectMd();
let headerLg = detectHeaderLg();

$(window).on("resize load", throttle(() => {
	const oldLg = lg;
	const oldMd = md;
	const oldHeaderLg = headerLg;
	lg = detectLg();
	md = detectMd();
	headerLg = detectHeaderLg();
	if (lg !== oldLg || md !== oldMd || headerLg !== oldHeaderLg)
	{
		callListeners();
	}
}, 50, { leading: true, trailing: true }));

export type BreakpointListener = (lg: boolean, md: boolean) => void;

const listeners: BreakpointListener[] = [];

export function listenForBreakpointChange(fn: BreakpointListener): void
{
	listeners.push(fn);
}

const callListeners = () => {
	each(listeners, (listener: BreakpointListener) => listener(lg, md));
};

function detectHeaderLg(): boolean
{
	return $headerLgDetect.css("left") === "1px";
}

function detectLg(): boolean
{
	return $lgDetect.css("left") === "1px";
}

function detectMd(): boolean
{
	return $mdDetect.css("left") === "1px";
}

export function onHeaderLargeScreen(): boolean
{
	return headerLg;
}

export function onHeaderSmallScreen(): boolean
{
	return !headerLg;
}

export function onLargeScreen(): boolean
{
	return lg;
}

export function onMediumScreen(orLarger = false): boolean
{
	if (orLarger)
	{
		return md;
	}
	return md && !lg;
}

export function onSmallScreen(): boolean
{
	return !md;
}

if (window["iw"] === undefined)
{
	window["iw"] = {};
}

window["iw"].breakpoints = {
	onSmallScreen,
	onMediumScreen,
	onLargeScreen,
	listenForBreakpointChange
};
